enum PaymenMethod {
  CASH = 'CASH',
  BANK_TRANSFER = 'Bank Transfer',
  GIRO = 'Giro',
  RETURN = 'Return'
}

export default PaymenMethod;
